import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../../configurations/server-config';

@Injectable({
  providedIn: 'root'
})
export class PassagerService {

  private API = 'http://167.86.110.120:8888';
  // private API = API_URL;

  constructor(private http: HttpClient) { }

  savepassagerVoyage(type: any): any {
    return this.http.post(`${API_URL}/passagervoyage`, type, {
      observe: 'response',
    });
  }

  updatepassagerVoyage(type: any): any {
    return this.http.put(`${API_URL}/passagervoyage`, type, {
      observe: 'response',
    });
  }

  getAllPassagerVoyage(page= 0, size= 10, sortby: any=null, orderby: any=null): any {
    return this.http.get(`${API_URL}/passagervoyage?page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`);
  }

  deletePassagerVoyage(id: any): any {
    return this.http.delete(`${API_URL}/passagervoyage/${id}`);
  }

  getPassagerVoyagelist(): any {
    return this.http.get(`${API_URL}/passagervoyagelist`);
  }

  getallticketinSession(session: any, page: any, size: any): any {
    return this.http.get(`${API_URL}/passagerinsessions?sid=${session}&page=${page}&size=${size}`);
  }

  getPassagerticketdetail(id: any): any {
    return this.http.get(`${API_URL}/getpassagerticketbyid?id=${id}`);
  }


  checkplaceavailability(id: any, place: any): any {
    return this.http.get(`${API_URL}/checkplaceavailable?id=${id}&pl=${place}`);
  }

  cancelticket(passager: any): any {
    return this.http.post(`${API_URL}/cancelticket`, passager);
  }

  searchByticket(name: string): any{
    return this.http.post(`${API_URL}/passagervoyage/searchticket?q=${name}`, null);
  }

  searchByNom(name: string): any{
    return this.http.post(`${API_URL}/passagervoyage/searchnom?q=${name}`, null);
  }

  searchByContact(name: string): any{
    return this.http.post(`${API_URL}/passagervoyage/searchcontact?q=${name}`, null);
  }

  searchByPrix(name: any): any{
    return this.http.post(`${API_URL}/passagervoyage/searchbyprix?q=${name}`, null);
  }

  getpassengerTripListWithPhoneAndName(name: any, contact:any): any{
    return this.http.post(`${this.API}/passagervoyage/searchnomandcontact?n=${name}&p=${contact}`, null);
  }


  // passenger list
  getAllPassagerList(page= 0, size= 10): any {
    return this.http.get(`${this.API}/passengerlist?page=${page}&size=${size}`);
  }

  getPassagerTripList(passengerid: any, page= 0, size= 10, sortby: any=null, orderby: any=null): any {
    return this.http.get(`${this.API}/passengertrip?page=${page}&size=${size}&id=${passengerid}&sortby=${sortby}&direction=${orderby}`);
  }

  updateTicketStatusAfterCount(Idpassager: any, freecode: any): any{
    return this.http.post(`${API_URL}/updateTicketStatusAfterCount?id=${Idpassager}&code=${freecode}`, null);
  }

  transferpassenger(idvoyage: any,oldvoayge: any,idpassager: any): any{
    return this.http.post(`${API_URL}/transferpassenger?id=${idpassager}&oid=${oldvoayge}&vid=${idvoyage}`, null);
  }

  searchpassenger(name: string): any{
    return this.http.post(`${this.API}/passager/search?q=${name}`, null);
  }

  convertTicket(data: any): any{
    return this.http.post(`${API_URL}/convertticket`, data);
  }

  transfertTicket(data: any): any{
    return this.http.post(`${API_URL}/transferticket`, data);
  }
}
